// extracted by mini-css-extract-plugin
export var activeFilterButton = "_lq-c";
export var backButton = "_lq-4";
export var backIcon = "_lq-5";
export var chevronShortcut = "_lq-6";
export var container = "_lq-1";
export var editor = "_lq-8";
export var editorWrapper = "_lq-7";
export var prefix = "_lq-2";
export var searchIcon = "_lq-3";
export var suffix = "_lq-9";
export var suffixContent = "_lq-a";
export var suffixText = "_lq-b";
export var wrapper = "_lq-0";